<template>
  <div id="app">
    <router-view />
  </div>
</template>

<style>
/* Global styles are in src/assets/style/global.css */
</style>
